import './LoadingSpinner.css';

export const LoadingSpinner = ({ size = 'medium', message = '' }) => {
  return (
    <div className="container-loadingspinner">
      <div className={`spinner-loadingspinner spinner-${size}-loadingspinner`}></div>
      {message && <p className="message-loadingspinner">{message}</p>}
    </div>
  );
};

export default LoadingSpinner;
